// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'da2d3e2d-b9c5-44f4-92ad-2d541dd3bacd',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '34f83b70-2bb3-4b0a-9502-630a32709fef',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Reward_Icon_Button',
      parent: 'da2d3e2d-b9c5-44f4-92ad-2d541dd3bacd'
    },
    {
      id: '1c9e9fa6-e788-4d9d-9153-d2638b791b5e',
      type: 'Sprite',
      name: 'offerIcon',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: 'da2d3e2d-b9c5-44f4-92ad-2d541dd3bacd'
    },
    {
      id: 'cc8adf14-d34e-45d7-aa93-b45613efd1d3',
      type: 'Container',
      name: 'labelContainer',
      className: '',
      x: 0,
      y: 47,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'da2d3e2d-b9c5-44f4-92ad-2d541dd3bacd'
    },
    {
      id: 'dd889a8a-6e84-46e0-a244-f261410bd855',
      type: 'Sprite',
      name: 'labelBg',
      className: '',
      x: 11,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Main_Menu_Icon_Counter_Full',
      parent: 'cc8adf14-d34e-45d7-aa93-b45613efd1d3'
    },
    {
      id: '4617c269-63da-4d41-a9b1-bc1362310cec',
      type: 'Sprite',
      name: '',
      className: '',
      x: -49,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Golden_Clock',
      parent: 'cc8adf14-d34e-45d7-aa93-b45613efd1d3'
    },
    {
      id: '9ec6c445-9a0a-4cb5-83db-020b336363f7',
      type: 'Text',
      name: '',
      className: 'upperCase_SPL',
      x: 11,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Sale',
      localize: true,
      maxWidth: 94,
      maxHeight: 46,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#aa1501',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'cc8adf14-d34e-45d7-aa93-b45613efd1d3'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  animations: [
    {
      id: 'f10e048b-ea2b-4493-abd9-c956beb6f79c',
      name: 'IdleAnimation',
      playingSpeed: 1,
      totalDuration: 5000,
      blocks: [
        {
          id: 'a3fad4a7-5d63-4070-a603-cf7fe5afc597',
          type: 'Tween',
          name: 'scaleUp',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '55440968-b038-494a-854d-e1502282bcf9',
          type: 'Tween',
          name: 'scaleDown',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 200,
          sourceName: 'root',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'fa871f3f-1c9d-4f8f-a25c-480de4693ce9',
          type: 'Tween',
          name: 'scaleUp_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 400,
          sourceName: 'root',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '3c7757e3-a02e-4b57-83c8-22d82bf63508',
          type: 'Tween',
          name: 'scaleDown_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 600,
          sourceName: 'root',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '3a315d40-ff1b-45da-8865-cb47c13697b5',
          type: 'Tween',
          name: 'scaleUp_copy_1',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 800,
          sourceName: 'root',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'b4d2ead8-a6c7-45fc-a478-3d52322f696c',
          type: 'Tween',
          name: 'scaleDown_copy_1',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1000,
          sourceName: 'root',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SpecialOfferMenuIconLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  offerIcon!: Sprite;
  labelContainer!: Container;
  labelBg!: Sprite;
  upperCase_SPL!: (Text)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class IdleAnimation {
  Layout: {
    root: object;
  };

  BlockTypeByName: {
    scaleUp: object;
    scaleDown: object;
    scaleUp_copy: object;
    scaleDown_copy: object;
    scaleUp_copy_1: object;
    scaleDown_copy_1: object;
  };

  flowData = raw.animations[0];
}
